import { DetailBox } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import GoBackToListButton from '../../../../components/buttons/GoBackToListButton';
import { PathsLayouts } from '../../../../config/routes';
import { useStudentCurrentAccountLoader } from './StudentCurrentAccountLoader';

// Reutiliza las labels del header de Cuenta corriente — mismo texto
// ("Estudiante" / N° identificación), evita duplicar claves i18n.
const keyPrefix = 'financialPortal.currentAccount.tabs.currentAccount.header';

/**
 * Header compartido por las 3 pestañas de la cuenta corriente del estudiante.
 * Se renderiza una sola vez sobre la barra de tabs (en index.tsx), de modo que
 * el botón "Volver al listado" y la identidad del estudiante (nombre + ID) sean
 * consistentes en todas las pestañas. El badge de estado financiero y las
 * acciones de bloqueo siguen viviendo en la pestaña Cuenta corriente (DebtHeader)
 * porque dependen del DebtLoader.
 */
export default function StudentAccountHeader() {
  const { t } = useTranslation();
  const { data: studentData } = useStudentCurrentAccountLoader();

  return (
    <Row className="align-items-center pt-3 pb-4">
      <Col xs="auto">
        <GoBackToListButton path={PathsLayouts.currentAccount} />
      </Col>
      <Col xs={12} md={4} className="ml-auto">
        <DetailBox
          columns={[
            {
              title: t(`${keyPrefix}.studentLabel`),
              body: studentData?.name ?? '',
              size: { xs: 12, md: 8 },
            },
            {
              title: t(`${keyPrefix}.idLabel`),
              body: studentData?.rutOrPassport ?? '',
              size: { xs: 12, md: 4 },
            },
          ]}
        />
      </Col>
    </Row>
  );
}
